import { z } from "zod";

export const MasteryLevel = z.enum(["NOT_STARTED", "DISCOVERING", "PRACTICING", "MASTERED"]);

export const NotionMasteryView = z.object({
  notionId: z.string(),
  slug: z.string(),
  title: z.string(),
  level: MasteryLevel,
  pKnown: z.number().min(0).max(1),
  attemptsCount: z.number().int(),
  nextReviewAt: z.string().datetime().nullable(),
  examWeight: z.number().min(0).default(0), // fréquence d'apparition dans les annales
});

export const ChapterProgress = z.object({
  chapterId: z.string(),
  title: z.string(),
  ordinal: z.number().int(),
  masteredPct: z.number().int().min(0).max(100),
  toReview: z.number().int(),
  examHint: z.string().nullable(), // « tombe souvent au BFEM »
});

/** Ce que voient l'accueil élève et le parent. */
export const MasterySummary = z.object({
  studentId: z.string(),
  examCode: z.string().nullable(),
  examReadinessPct: z.number().int().min(0).max(100).nullable(),
  streakDays: z.number().int(),
  weekActiveSec: z.number().int(),
  chapters: z.array(ChapterProgress),
  notions: z.array(NotionMasteryView),
});
export type MasterySummary = z.infer<typeof MasterySummary>;
